// define variable for travel time and locations default list
var insuranceLocationList;
var datePickerMode = localStorage.getItem("datePickerMode") ? Number(localStorage.getItem("datePickerMode")) : 2;

initDatepicker();

$(function () {
  if (window.insuranceDays && window.insuranceDays.length) {
    appendTravelTimeList(window.insuranceDays);
  }

  if (window.insuranceLocation && window.insuranceLocation.length) {
    insuranceLocationList = window.insuranceLocation;
  } else {
    $.get("/insurance/getcountries/", function (data, status) {
      if (data.model && data.model.length) {
        insuranceLocationList = data.model;
      }
    });
  }

  $.get("/insurance/getdurationsofstay/?all=true", function (data, status) {
    if (data.model && data.model.length) {
      appendTravelTimeList(data.model);
    }
  });

  // toggle travel time list
  $(".js-toggle-insurance-time").click(function () {
    $(this).closest(".js-insurance-time").toggleClass("is-open");
    if (window.innerWidth < 993) {
      $("html").toggleClass("no-scroll");
    }
  });

  // close travel time list
  $("body").on("click", function (event) {
    if (!$(event.target).closest(".js-insurance-time").length) {
      if ($(".js-insurance-time").hasClass("is-open")) {
        $(".js-insurance-time").removeClass("is-open");

        if (window.innerWidth < 993) {
          $("html").toggleClass("no-scroll");
        }
      }
    }
  });

  // change travel time value
  $("body").delegate(".js-insurance-time-item", "click", function () {
    $(".js-insurance-time-value").html($(this).html());
    $(".js-insurance-time-value").attr("data-value", $(this).attr("data-value"));
    $(".js-insurance-time").removeClass("is-open");
    if (window.innerWidth < 993) {
      $("html").toggleClass("no-scroll");
    }

    let timeOut = setTimeout(() => {
      document.querySelector(".js-toggle-person-list").click();
      clearTimeout(timeOut);
    }, 100);
  });

  // toggle person list
  $(".js-toggle-person-list").click(function () {
    $(".js-toggle-person").toggleClass("is-open");
    if (window.innerWidth < 993) {
      $("html").toggleClass("no-scroll");
    }
  });

  // close person list
  $("body").on("click", function (event) {
    if (!$(event.target).closest(".js-toggle-person").length) {
      if ($(".js-toggle-person").hasClass("is-open")) {
        $(".js-toggle-person").removeClass("is-open");

        $("html").removeClass("no-scroll");
      }
    }
  });

  // change insurance person count and create input for person birth date
  $(".js-person-item").click(function () {
    $("html").removeClass("no-scroll");

    var personCount = Number($(this).attr("data-value"));
    $(".js-person-value").html($(this).html());
    $(".js-person-value").attr("data-value", personCount);
    $(".js-toggle-person").removeClass("is-open");

    var datepickerItemLength = $(".js-inc-datepicker-item").length;

    if (personCount !== datepickerItemLength) {
      if (personCount > datepickerItemLength) {
        for (var i = datepickerItemLength + 1; i <= personCount; i++) {
          $(".js-inc-datepicker").append(
            "\
        <div class='insurance-booking__input insurance-booking__input--calendar js-inc-datepicker-item js-insurance-booking-input'>\
            <div class='insurance-booking__calendar js-inc-datepicker-calendar-new'>\
                <input type='text' data-hj-whitelist readonly class='js-pick-date pickDate' placeholder='تاریخ تولد مسافر " +
              i +
              "'>\
                <input type='hidden' />\
            </div>\
        </div>"
          );
        }

        initDatepicker();
      } else {
        for (var i = datepickerItemLength - 1; i >= personCount; i--) {
          $(".js-inc-datepicker-item")[i].remove();
        }
      }
    }

    let timeOut = setTimeout(() => {
      $(".js-inc-datepicker-item").find(".js-pick-date").eq(0).datepicker("show"); // show first datePicker
      clearTimeout(timeOut);
    }, 100);
  });

  $(".js-insurance-booking .js-inc-datepicker-calendar").pickDate({
    dateFormat: "yy/mm/dd",
    dateFormatEn: "yy M dd",
    changeMonthAllow: true,
    changeYearAllow: true,
    showButtonPanel: true,
    isDependenceDates: false,
    showCurrentAtPos: 0,
    numberOfMonths: 1,
    yearRange: "c-100:+00",
    minDate: "1300/01/01",
    maxDate: new Date(),
    customClass: "lightTheme",
    showAllMonthsinList: false,
    langType: datePickerMode === 1 ? '':'fa',
    blurInmobile: true,
    dayNamesShortFa: ["1شنبه", "2شنبه", "3شنبه", "4شنبه", "5شنبه", "جمعه", "شنبه"],
    dayNamesShortEn: ["Su", "Mo", "TU", "We", "Th", "Fr", "Sa"],
    enterDateTitle: "تاریخ تولد مسافر",
    enterDateTitleEn: "Passenger date of birth",
    fillHidden: {
      enable: true,
      outPut: "en", //en | Dependent_On_SelectedDate | fa
      customformatInhidden: "YYYY-MM-DD",
    },
  });

  $(".js-search-insurance").click(function () {
    var localStorageKey = `${window.prefixSearchHistory}-${
      $(".js-search-holder-landing").attr("id") ||
      $(this).closest(".js-tab-nav").find(".js-tab-content>div.active").attr("id")
    }`;
    var searchHistoryItem = {
      value: {},
      baseUrl: "",
      expire: "",
    };

    var baseUrl = "/fa/Insurance/result/?";
    var valid = true;

    $(".js-insurance-booking").find(".js-error-message").remove();
    $(".js-insurance-booking-input").removeClass("error");

    var countryField = $(".js-insurance-location").data();
    if (countryField.code) {
      // $(".js-insurance-location").data("code")
      searchHistoryItem.value.country = {
        code: countryField.code,
        value: countryField.value,
      };

      baseUrl += "CountryCode=" + countryField.code; //$(".js-insurance-location").data("code")
    } else {
      $(".js-insurance-location").closest(".js-insurance-booking-input").addClass("error");
      valid = false;
    }

    if ($(".js-insurance-time-value").attr("data-value")) {
      searchHistoryItem.value.duration = $(".js-insurance-time-value").data("value");
      searchHistoryItem.value.durationText = $(".js-insurance-time-value")[0].innerText;
      baseUrl += "&DurationOfStay=" + $(".js-insurance-time-value").data("value");
    } else {
      $(".js-insurance-time-value").closest(".js-insurance-booking-input").addClass("error");
      valid = false;
    }

    searchHistoryItem.value.personCount = $(".js-insurance-booking .pickDate").length;
    searchHistoryItem.value.birthDate = [];
    $(".js-insurance-booking .pickDate").each(function (index, value) {
      if ($(this).val() !== "") {
        searchHistoryItem.value.birthDate[index] = $(this).next().val();
        baseUrl += "&BirthDate[" + index + "]=" + $(this).next().val();
      } else {
        searchHistoryItem.value.birthDate[index] = "";
        $(this).closest(".js-insurance-booking-input").addClass("error");
        valid = false;
      }
    });

    if (!valid) {
      $(".js-insurance-booking").append(
        "<span class='form-validation js-error-message'>لطفا تمام فیلدها را کامل نمایید</span>"
      );

      return false;
    } else {
      searchHistoryItem = {
        ...searchHistoryItem,
        baseUrl: baseUrl,
        expire: moment().add(1, "months").format("YYYY-MM-DD"),
      };
      window.updateLocalStorage(localStorageKey, searchHistoryItem);
      window.location.assign(baseUrl);
    }
  });

  // init autoComplete
  $(".js-insurance-location")
    .autocomplete({
      minLength: 0,
      delay: 400,
      source: function (request, response) {
        if (request.term === "") {
          var items = insuranceLocationList && insuranceLocationList.length ? insuranceLocationList : [];

          response(items);
        } else {
          var url = getResult($(".js-insurance-location"));
          $.getJSON(url).done(function (serverResponse) {
            response(serverResponse.model);
          });
        }
      },

      appendTo: $(".js-insurance-location").next(),
      search: function () {
        if (window.innerWidth < 993) {
          $(this).closest(".js-insurance-booking-input").addClass("is-open");
          $("html").addClass("no-scroll");
        }
      },
      open: function () {
        $(this).closest(".js-insurance-booking-input").addClass("is-open");
        $(this).parent().find(".js-autocomplete-list").show();

        $(".ui-autocomplete").off("menufocus hover mouseover mouseenter");
        //off autocomplete in chrome
        let chromeAgent = navigator.userAgent.indexOf("Chrome") != -1;
        if (chromeAgent) {
          $(this).attr("autocomplete", "off");
        } else {
          $(this).attr("autocomplete", "new-value");
        }
        var inputObj = $(this);
        inputObj
          .next(".js-autocomplete-list")
          .children("ul")
          .css({
            top: "+=" + 4,
          });
      },
      close: function (e, ui) {
        $("html").removeClass("no-scroll");
      },
      select: function (event, ui) {
        $(this).attr("data-code", ui.item.code);
        $(this).attr("data-value", ui.item.title);
        $(this).val();

        $(this).data({
          code: ui.item.code,
          value: ui.item.title,
        });

        $(this).attr("placeholder", ui.item.title);

        $(this).closest(".js-insurance-booking-input").removeClass("is-open");
        $(".js-insurance-location").autocomplete("close");

        let timeOut = setTimeout(() => {
          document.querySelector(".js-toggle-insurance-time").click();
          clearTimeout(timeOut);
          document.activeElement.blur();
        }, 100);
      },
    })
    .bind("focus", function () {
      $(this).val("");
      $(this).autocomplete("search");
    })
    .bind("blur", function () {
      $(this).val($(this).attr("placeholder"));
    })
    .autocomplete("instance")._renderItem = function (ul, item) {
    var li = "";
    li +=
      '<li><span class="item-wrapper">' +
      '<i class="icon-map"></i><div><span class="city-title">' +
      item.title +
      "</span></li>";

    return $(li).appendTo(ul);
  };

  // close location
  $(".js-insurance-booking").delegate(".js-close-location-list", "click", function () {
    $(this).closest(".js-insurance-booking-input").removeClass("is-open");
    $(".js-insurance-location").autocomplete("close");
  });
});

$(".js-insurance-location").click(() => {
  $(".js-insurance-location").trigger("focus");
  $(".js-insurance-location").trigger("search");
});

// init datePicker
function initDatepicker() {
  $(
    ".js-insurance-booking .js-inc-datepicker-calendar-new, .js-insurance-booking .js-inc-datepicker-calendar"
  ).pickDate({
    dateFormat: "yy/mm/dd",
    dateFormatEn: "yy M dd",
    changeMonthAllow: true,
    changeYearAllow: true,
    showButtonPanel: true,
    isDependenceDates: false,
    showCurrentAtPos: 0,
    numberOfMonths: 1,
    yearRange: "c-100:+00",
    minDate: "1300/01/01",
    maxDate: new Date(),
    customClass: "lightTheme",
    showAllMonthsinList: false,
    langType: datePickerMode === 1 ? '':'fa',
    blurInmobile: true,
    dayNamesShortFa: ["1شنبه", "2شنبه", "3شنبه", "4شنبه", "5شنبه", "جمعه", "شنبه"],
    dayNamesShortEn: ["Su", "Mo", "TU", "We", "Th", "Fr", "Sa"],
    enterDateTitle: "تاریخ تولد مسافر",
    enterDateTitleEn: "Passenger date of birth",
    fillHidden: {
      enable: true,
      outPut: "en", //en | Dependent_On_SelectedDate | fa
      customformatInhidden: "YYYY-MM-DD",
    },
    onSelectEvent: function () {
      let nextDatePicker = $(this).closest(".js-inc-datepicker-item").next(".js-insurance-booking-input");
      if (Boolean(nextDatePicker.length)) {
        let timeOut = setTimeout(() => {
          nextDatePicker.find(".js-pick-date").datepicker("show");
          clearTimeout(timeOut);
        }, 100);
      }
    },
  });
}

// update auto complete after type
function getResult(input) {
  var dataUrl = "/insurance/getcountries/?Keyword=";

  if (input.val()) {
    dataUrl += input.val();
  }
  return dataUrl;
}

// append insurance travel time list item
function appendTravelTimeList(items) {
  $(".js-insurance-time-list").empty();

  if (items && items.length) {
    items.forEach(function (item) {
      $(".js-insurance-time-list").append(
        "<li class='js-insurance-time-item' data-value='" + item.value + "'>" + item.title + "</li>"
      );
    });
  }
}
